module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('view-box', {
    ref: "scroller",
    attrs: {
      "body-padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/banner.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/wkb_logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/timeline.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-placeholder"
  }, [_c('sticky', {
    attrs: {
      "scroll-box": "vux_view_box_body",
      "check-sticky-support": false
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.activities), function(activity, index) {
    return _c('li', {
      key: index,
      staticClass: "cf"
    }, [(index % 2 === 0) ? _c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/nav_odd.png"
      }
    }) : _vm._e(), _vm._v(" "), (index % 2 === 1) ? _c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/nav_even.png"
      }
    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(activity.title))])])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._l((_vm.activities), function(activity, index) {
    return _c('div', {
      key: index,
      staticClass: "activity"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "outer-title"
    }, [_c('div', {
      staticClass: "inner-title"
    }, [_vm._v(_vm._s(activity.title))])])]), _vm._v(" "), (activity.type === 'seckill') ? _c('div', [_c('div', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "cf"
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/activity_top.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "main"
    }, [_c('div', {
      staticClass: "pre-seckill"
    }, [_c('div', {
      staticClass: "previes-img cf",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": activity.previewImg
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "cf"
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/activity_bottom.png"
      }
    })])])]) : _vm._e(), _vm._v(" "), (activity.type === 'booking') ? _c('div', _vm._l((_vm.bookingList), function(list, index) {
      return _c('div', {
        key: index,
        staticClass: "body body-booking"
      }, [_c('div', {
        staticClass: "cf"
      }, [_c('img', {
        staticClass: "response fl",
        attrs: {
          "src": "static/images/activity_top.png"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "main"
      }, [_c('div', {
        staticClass: "booking cf",
        on: {
          "click": function($event) {
            _vm.goToBookingPage('bookingList', index)
          }
        }
      }, [_c('div', {
        staticClass: "left fl"
      }, [_c('img', {
        staticClass: "response fl",
        attrs: {
          "src": list.previewImg
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "icon",
        attrs: {
          "src": "static/images/booking_new.png"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "right fr"
      }, [_c('div', {
        staticClass: "des"
      }, [_c('p', {
        staticClass: "des-title"
      }, [_vm._v(_vm._s(list.title))]), _vm._v(" "), _vm._l((list.dess), function(des, index) {
        return _c('p', {
          key: index,
          staticClass: "des-features"
        }, [_vm._v(_vm._s(des))])
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "appointment cf"
      }, [_c('p', {
        staticClass: "price fl"
      }, [_vm._v(_vm._s(list.lowestPrice))]), _vm._v(" "), _c('span', {
        staticClass: "btn fr"
      }, [_vm._v("立即购买")])])])])]), _vm._v(" "), _c('div', {
        staticClass: "cf"
      }, [_c('img', {
        staticClass: "response fl",
        attrs: {
          "src": "static/images/activity_bottom.png"
        }
      })])])
    })) : _vm._e(), _vm._v(" "), (activity.type === 'scratch') ? _c('div', [_c('div', {
      staticClass: "special body body-booking"
    }, [_c('div', {
      staticClass: "cf"
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/activity_top.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "main"
    }, _vm._l((_vm.specialList), function(list, index) {
      return _c('div', {
        key: index,
        staticClass: "booking cf",
        on: {
          "click": function($event) {
            _vm.goToBookingPage('specialList', index)
          }
        }
      }, [_c('div', {
        staticClass: "left fl"
      }, [_c('img', {
        staticClass: "response fl",
        attrs: {
          "src": list.previewImg
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "icon",
        attrs: {
          "src": "static/images/booking_new_2.png"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "right fr"
      }, [_c('div', {
        staticClass: "des"
      }, [_c('p', {
        staticClass: "des-title"
      }, [_vm._v(_vm._s(list.title))]), _vm._v(" "), _vm._l((list.dess), function(des, index) {
        return _c('p', {
          key: index,
          staticClass: "des-features"
        }, [_vm._v(_vm._s(des))])
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "appointment cf"
      }, [_c('p', {
        staticClass: "price fl"
      }, [_vm._v(_vm._s(list.lowestPrice))]), _vm._v(" "), _c('span', {
        staticClass: "btn fr"
      }, [_vm._v("立即购买")])])])])
    })), _vm._v(" "), _c('div', {
      staticClass: "cf"
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/activity_bottom.png"
      }
    })])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "activity"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "outer-title"
  }, [_c('div', {
    staticClass: "inner-title"
  }, [_vm._v("活动规则")])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "cf"
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/images/activity_top.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main all-rules"
  }, [_c('ul', {
    staticClass: "all-rules-nav"
  }, _vm._l((_vm.activities), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: _vm.currentRule === index
      },
      on: {
        "click": function () {
          _vm.currentRule = index;
        }
      }
    }, [_c('div', [_c('p', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), (index === _vm.currentRule) ? _c('img', {
      attrs: {
        "src": "static/images/pre_seckill_bottom_arrow.png"
      }
    }) : _vm._e()])
  })), _vm._v(" "), _c('ul', {
    staticClass: "all-rules-rule"
  }, _vm._l((_vm.activities[_vm.currentRule].rules), function(rule, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "left"
    }, [_c('img', {
      attrs: {
        "src": 'static/images/no.' + (index + 1) + '.png'
      }
    })]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(rule))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "cf"
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/images/activity_bottom.png"
    }
  })])])])], 2), _vm._v(" "), _c('m-footer')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "fixed-btn"
  }, [_c('div', {
    staticClass: "text-btn"
  }, [_c('p', {
    on: {
      "click": function($event) {
        _vm.showMyPriceDialog = true
      }
    }
  }, [_vm._v("订单")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        _vm.showRules = true
      }
    }
  }, [_vm._v("规则")])]), _vm._v(" "), (_vm.showFixedBtn) ? _c('div', {
    staticClass: "to-top",
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "src": "static/images/to_top.png"
    }
  })]) : _c('div', {
    staticClass: "to-top",
    staticStyle: {
      "box-shadow": "none",
      "background-color": "rgba(0, 0, 0, 0)"
    }
  })]), _vm._v(" "), _c('x-dialog', {
    staticClass: "rules",
    model: {
      value: (_vm.showRules),
      callback: function($$v) {
        _vm.showRules = $$v
      },
      expression: "showRules"
    }
  }, [_c('div', {
    staticClass: "head cf"
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/images/rules_bg.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("活动规则")]), _vm._v(" "), _c('span', {
    staticClass: "vux-close",
    on: {
      "click": function($event) {
        _vm.showRules = false
      }
    }
  })]), _vm._v(" "), _c('div', [_c('tab', {
    attrs: {
      "active-color": "#fd424a"
    }
  }, _vm._l((_vm.activities), function(activity, index) {
    return _c('tab-item', {
      key: index,
      attrs: {
        "selected": _vm.currentRule === index
      },
      on: {
        "on-item-click": function($event) {
          _vm.currentRule = index
        }
      }
    }, [_vm._v(_vm._s(activity.title))])
  })), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.activities[_vm.currentRule].rules), function(rule, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(index + 1) + "、" + _vm._s(rule))])
  }))], 1)]), _vm._v(" "), _c('x-dialog', {
    attrs: {
      "scroll": true,
      "dialog-style": {
        'max-width': 'none',
        'background': 'transparent',
        'text-align': 'left',
        'overflow': 'visible'
      }
    },
    model: {
      value: (_vm.showMyPriceDialog),
      callback: function($$v) {
        _vm.showMyPriceDialog = $$v
      },
      expression: "showMyPriceDialog"
    }
  }, [_c('div', {
    staticClass: "coupons-dialog cf"
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/images/coupon_bg.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "coupons-dialog-close",
    attrs: {
      "src": "static/images/close.png"
    },
    on: {
      "click": function($event) {
        _vm.showMyPriceDialog = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupons-dialog-btn"
  }, [_c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/wx.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("查看订单请关注悟空保微信号iwukongbao，进入“我的>个人中心>我的订单”查看")]), _vm._v(" "), _c('p', {
    staticClass: "scratch-dialog-yes",
    on: {
      "click": function($event) {
        _vm.showMyPriceDialog = false
      }
    }
  }, [_vm._v("我知道了")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7b4dfd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 436
// module chunks = 1